import PageTitle from '../components/PageTitle';
import NewOtherScheduleForm from '../features/new-other-schedule/NewOtherScheduleForm';
import { Navigate, useNavigate } from 'react-router-dom';
import { useIsActiveSubscription } from '../hooks/use-is-active-subscription';
import { useIsWorkpaperRole } from '../hooks/use-is-workpaper-role';
import { ButtonV2 } from '@cimplico/components';
import NewOtherScheduleTabs from '../features/new-other-schedule/NewOtherScheduleTabs';
import { useState } from 'react';
import CopyPriorOtherScheduleForm from '../features/new-other-schedule/CopyPriorOtherScheduleForm';
import CimplicoStaffGuard from '../components/cimplico-staff-guard/CimplicoStaffGuard';

function NewOtherSchedulePage(): JSX.Element {
    const activeSubscription = useIsActiveSubscription();
    const { isGuest } = useIsWorkpaperRole();
    const navigate = useNavigate();
    const [newScheduleContext, setNewScheduleContext] = useState('current');

    if (!activeSubscription || isGuest) {
        return <Navigate to=".." />;
    }

    function cancel() {
        navigate('..');
    }

    return (
        <div className="pb-4">
            <div className="pb-4 flex justify-between">
                <PageTitle title="New Schedule" />
                <ButtonV2 type="secondary" label="Cancel" size="sm" onClick={cancel} />
            </div>
            <div className="border-b">
                <CimplicoStaffGuard>
                    <NewOtherScheduleTabs onChange={setNewScheduleContext} />
                </CimplicoStaffGuard>
            </div>

            <div className="mx-auto w-full flex justify-center mt-8">
                {newScheduleContext === 'current' && <NewOtherScheduleForm />}
                {newScheduleContext === 'prior' && <CopyPriorOtherScheduleForm />}
            </div>
        </div>
    );
}
export default NewOtherSchedulePage;
